// removed by extract-text-webpack-plugin
module.exports = {"display":"_36uqOCgKqTpsOQvNsh3f1V","display1":"_1gJwR0BR9tqfqstvRfRgjh","display2":"_1B3kCveSD9-yJ0uMxwZEdZ","display3":"_3nfKvDkPftNIouekEJrnZj","display4":"_3I7lkwcYL8WtaeEM_l2_Q5","display5":"YePq4NonuIHguAT7gn4bC","bold":"_2b_MxUssSAmWNrnoUn9ctl","italic":"_3ZCt1qxHDDDdKp1MteAz5q","block":"_1LUvWr9rlNIrMCz_fP93pt"};


//////////////////
// WEBPACK FOOTER
// ./src/SPRINTA/v2/atoms/Display/style.module.css
// module id = 475
// module chunks = 38